import { IS_ADMIN } from "../../constants/Constants.js";

let AdminUser =  {
    items: [
        {
            title: true,
            name: "USER"  
        },
        {
            name: "Kasm",
            url: "/userdashboard",
            icon: "fa fa-desktop",
        },
        {
            name: "Launch Now",
            url: "/go",
            icon: "fa fa-arrow-circle-right",
        },
        {
            name: "Profile",
            url: "/adminprofile",
            icon: "fa fa-user-circle",
        },
        {
            title: true,
            name: "Adminstration",
            wrapper: {
                element: "",
                attributes: {
                }
            },
        },
        {
            name: "Dashboard",
            url: "/dashboard",
            icon: "icon-chart",
        },
        {
            name: "Users",
            url: "/adminUser",
            icon: "icon-user",
        },
        {
            name: "Groups",
            url: "/groups",
            icon: "fa fa-users",
        },
        {
            name: "Agents",
            url: "/agents",
            icon: "fa fa-server",
        },
        {
            name: "Managers",
            url: "/managers",
            icon: "fa fa-shield",
        },
        {
            name: "Zones",
            url: "/zones",
            icon: "fa fa-map",
        },
        {
            name: "Kasms",
            url: "/kasm",
            icon: "fa fa-table",
        },
        {
            name: "Images",
            url: "/images",
            icon: "fa fa-image",
        },
        {
            name: "Developers",
            url: "/developers",
            icon: "fa fa-code-fork"
        },
        {
            name: "Web Filter",
            url: "/webfilter",
            icon: "fa fa-ban"
        },
        {
            name: "Branding",
            url: "/branding",
            icon: "fa fa-paint-brush"
        },
        {
            name: "Settings",
            url: "/settings",
            icon: "fa fa-wrench",
        },
        {
            name: "Authentication",
            icon: "fa fa-key",
            children: [
                {
                    name: "LDAP",
                    url: "/ldap",
                    icon: "fa fa-book",
                },
                {
                    name: "SAML",
                    url: "/saml",
                    icon: "fa fa-book",
                },
            ]
        },
        {
            name: "System Info",
            url: "/systeminfo",
            icon: "fa fa-info",
        },
        {
            name: "Logging",
            url: "/logging",
            icon: "icon-pencil"
        },
        {
            name: "Logout",
            url: "/logout",
            icon: "icon-logout",
        },
    ]
};


let normalUser = {
    items: [
        {
            title: true,
            name: "USER",
        },
        {
            name: "Kasm",
            url: "/userdashboard",
            icon: "fa fa-desktop",
        },
        {
            name: "Launch Now",
            url: "/go",
            icon: "fa fa-arrow-circle-right",
        },
        {
            name: "Profile",
            url: "/userprofile",
            icon: "fa fa-user-circle",
        },
        {
            name: "Logout",
            url: "/logout",
            icon: "icon-logout",
        },
    ]
};

let navBar = null;

if(IS_ADMIN){
    navBar =  AdminUser;
}
else{
    navBar =   normalUser;
}

export default navBar; 


// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js